(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('UrgentIssues', UrgentIssues);

    UrgentIssues.$inject = ['$resource'];

    function UrgentIssues($resource) {
        var resourceUrl = 'api/urgent-issues/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'byChart': {url: 'api/urgent-issues/by-chart/:id', method: 'GET', isArray: true},
            'update': {method: 'PUT'},
            'countByChartIds': {url: 'api/urgent-issues/count-by-chart-ids/:chartIds', method: 'GET', isArray: true},
            'check': {url: 'api/urgent-issues/check', method: 'PUT'},
            'filter': {url: 'api/urgent-issues/filter', method: 'GET', isArray: true},
            'getAllEmployeeByUrgentIssue': {
                url: 'api/urgent-issues/employees/:id',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
